import { useState, useCallback, useMemo, useEffect } from 'react';
import { UseConfirm, UseConfirmParams } from '../types';

export const useConfirm = (): UseConfirm => {
  const [params, setParams] = useState<UseConfirmParams>();
  const [isSuccess, setIsSuccess] = useState(false);
  const close = useCallback(() => setParams(undefined), []);

  const confirm = useCallback(() => {
    if (!params) return;
    params.onConfirm();
    setIsSuccess(true);

    const timeout = setTimeout(close, 1000);
    return () => clearTimeout(timeout);
  }, [params, close]);

  useEffect(() => {
    if (!params) setIsSuccess(false);
  }, [params]);

  useEffect(() => {
    if (!params) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Escape') close();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [params, close]);

  return useMemo(
    () => ({
      params,
      isSuccess,
      open: setParams,
      close,
      confirm,
    }),
    [params, isSuccess, close, confirm],
  );
};
